
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const AcneAndScars = () => {
  const treatments = [
    {
      name: "AquaFirme Glow Facial",
      href: "/treatments/aquafirme",
      description: "Deep cleansing and hydration to balance oil production",
      price: "$199",
      memberPrice: "$149"
    },
    {
      name: "VI Peel",
      href: "/treatments/vi-peel",
      description: "Chemical peel to reduce acne and smooth scarring",
      price: "$299",
      memberPrice: "$229"
    },
    {
      name: "Laser Facial",
      href: "/treatments/laser-facial",
      description: "Target acne bacteria and improve skin texture",
      price: "$450",
      memberPrice: "$349"
    },
    {
      name: "RF Microneedling",
      href: "/treatments/rf-microneedling",
      description: "Stimulate collagen to reduce scarring and pores",
      price: "$649",
      memberPrice: "$499"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Acne & Acne Scars"
      subtitle="Glow Starts With Clarity"
      description="From breakouts to post-acne scarring, we treat all stages with advanced, non-surgical therapies designed to calm inflammation, balance oil, and restore smoothness. Best for hormonal acne, cystic outbreaks, post-inflammatory scarring, and congestion."
      treatments={treatments}
      beforeAfterText="Clear results in 1–3 visits. No downtime required for most treatments."
    />
  );
};

export default AcneAndScars;
